exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader[data-v-1c16ecdb]{margin:0;position:absolute;top:50%;left:50%;-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loaderPosition[data-v-1c16ecdb]{position:relative}.error-message[data-v-1c16ecdb]{margin:0;padding:0;list-style:none;margin-top:6px;font-size:12px;color:#f44455}", ""]);

// exports
